<template>
    <div v-if="visible">
        <xx-image-viewer v-bind="$attrs" :on-close="close"></xx-image-viewer>
    </div>
</template>

<script>

export default {
    props: {
        // 外面用的时候 sync
        visible: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        close() {
            this.$emit('update:visible', false);
        }
    },
};
</script>

<style lang="scss" scoped>

</style>
